import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  occasion_id: Yup.string().required("Occasion is required!"),
  reserve_date: Yup.string().required("Reserve date is required!"),
  is_active: Yup.string().required("Status is required!"),
});
